<template>
  <div class="reappro">
    <div class="reappro__number-container">
      <span class="reappro__number">N° {{ item.sh_number }} |</span>
      <span class="reappro__date">{{ item.order_date | moment("D/MM/YYYY")}}</span>
    </div>
    <div class="reappro__products">
      <img src="/static/img/pictos/nombredeproduits.svg">
      <span>Nombre de produits :</span> <span class="bleu">{{ item.lines.length }}</span>
    </div>
    <div class="reappro__products" v-if="item.status >= 1 && item.status < 9">
      <img src="/static/img/pictos/nombredeproduits.svg">
      <span>Quantité commandée :</span> <span class="bleu">{{ getTotalQte }}</span><span v-if="item.status >= 2"> expédée :</span><span v-if="item.status >= 2" class="bleu"> {{ getTotalShippedQuantity }}</span>
    </div>
    <div class="reappro__user">
      <img src="/static/img/pictos/commandepar.svg">
      <span>Commandée par :</span> <span class="bleu">{{ item.created_by_user.firstname }} {{ item.created_by_user.lastname }}</span>
    </div>
    <div class="reappro__bottom">
      <div class="reappro__status-container">
        <div class="reappro__status">
          <span>Statut : <strong>{{ $t('order.statuses.'+item.status) }}</strong></span>
        </div>
        <div class="reappro__completion-container completion">
          <div class="part completion__part1" v-if="item.status != 5 && item.status != 9"></div>
          <div class="part completion__part2" v-if="item.status >= 3 && (item.status != 5 && item.status != 9)"></div>
          <div class="part completion__part3" v-if="item.status == 4"></div>
          <div class="part completion__complete" v-if="item.status == 5"></div>
          <div class="part completion__refused" v-if="item.status == 9"></div>
        </div>
      </div>
      <router-link
        v-if="item.id && item.status == 0"
        :to="{name: 'ReapproNext', params: {id:item.id}}"
        class="reappro__btn-container"
      >
        <a class="reappro__btn">
          <img src="/static/img/pictos/flecheblanche.svg">
        </a>
      </router-link>
      <router-link
        v-else-if="item.id && item.status == 3"
        :to="{name: 'ReapproRecept', params: {id:item.id}}"
        class="reappro__btn-container"
      >
        <a class="reappro__btn">
          <img src="/static/img/pictos/flecheblanche.svg">
        </a>
      </router-link>
      <router-link
        v-else
        :to="{name: 'ReapproDetail', params: {id:item.id}}"
        class="reappro__btn-container"
      >
        <a class="reappro__btn">
          <img src="/static/img/pictos/flecheblanche.svg">
        </a>
      </router-link>
    </div>
  </div>
  <!-- <div class="reappro reappro--mobile" v-else>


  </div> -->
</template>

<script>
export default {
  name: "Reappro",
  props: [
    "item",
    "repass"
  ],
  data() {
    return {

      }
  },
  computed: {
    getTotalQte(){
      var quantity = 0;
      this.item.lines.map(item => {
        quantity = quantity + item.quantity;
      });
      return quantity;
    },
    getTotalShippedQuantity(){
      var shippedQuantity = 0;
      this.item.lines.map(item => {
        shippedQuantity = shippedQuantity + item.shipped_quantity
      });
      return shippedQuantity;
    }
  },
  mounted() {
    // this.$store.dispatch("company/getAll").then(() => {
    //   this.detail = this.$store.getters["company/getItem"](
    //     this.$route.params.id
    //   );
    // });
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .reappro{ border-bottom: 1px solid $color1; padding-bottom: 20px; margin-bottom: 20px; position: relative;
    &:last-of-type{ border-bottom: none; }
    &__user{ font-family: 'ClanPro'; font-size: 12px; color: $grisfonce;
      img{ width: 20px; margin-right: 5px; }
      span{
        &.pour{ margin-left: 80px; }
        &.bleu{ color: $color1; }
      }
    }
    &__products{ font-family: 'ClanPro'; font-size: 12px; color: $grisfonce; margin-bottom: 10px;
      img{ width: 20px; margin-right: 5px; }
      span{
        &.bleu{ color: $color1; }
      }
    }
    &__number{ color: $color1; font-family: 'ClanPro'; font-size: 15px; }
    &__date{ color: $color1; font-family: 'ClanProBold'; font-weight: normal; font-size: 15px; }
    &__number-container{ margin-bottom: 10px; }
    &__bottom{ display: flex;
    }
    &__btn{ background-color: $color2; width: 110px; display: flex; height: 50px; align-items: center; justify-content: center;
      img{ width: 20px; }
    }
    &__btn-container{ width: 110px; text-align: center;
      span{ color: $color2; font-family: 'ClanProBold'; font-size: 12px; }
      &:hover{ text-decoration: none; }
    }
    &__status-container{ flex: 1; justify-content: flex-end; display: flex; flex-direction: column; margin-right: 10px;
      span{ margin-bottom: 10px; margin-left: 10px; display: inline-block; font-size: 14px; }
    }
    .completion{ background-color: $grisclair; height: 7px; width: 100%; border-radius: 3px; display: flex;
      .part{ height: 100%; border-top-right-radius: 3px; border-bottom-right-radius: 3px; }
      &__part1{ width: calc(100% / 3); background-color: $jaune; }
      &__part2{ width: calc(100% / 3); background-color: $color2; }
      &__part3{ width: calc(100% / 3); background-color: $vertfonce; }
      &__complete{ width: 100%; background-color: $vertfonce; }
      &__refused{ width: 100%; background-color: $rouge; }
    }
    &--detail{
      .reappro__bottom{ margin-top: 20px; }
      .reappro__btn-container{ display: none; }
    }
    &--mobile{
      .reappro__repass{ padding: 10px;
        span{ margin-right: 20px; }
      }
      .reappro__bottom{ padding: 0 10px; }
      .reappro__number-container, .reappro__products, .reappro__user{ margin-left: 20px; margin-right: 20px; }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Reappro/Reappro.vue